import { Cell } from "@tanstack/react-table";

/**
 * Resolves external path for a cell when the column defines meta.externalPath.
 * Used by DataTableCellContent to render external link (EntityListLink).
 */
export function getCellExternalPath<TData>(
  cell: Cell<TData, unknown>,
): string | undefined {
  const externalPath = cell.column.columnDef.meta?.externalPath;
  if (typeof externalPath !== "function") return undefined;
  return externalPath(cell.row.original);
}
